import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../../../api/module/httpClient";
import moment from "moment";
import { Collapse, Space } from "antd";
import { CustomButton } from "../../../../components";
import CallForFacultyClassItem from "./CallForFacultyClassItem";

const { Panel } = Collapse

export default function CallForFaculty({ userProfile, setTab }) {

  useEffect(() => {
    setTab(2)
  }, []);

  const params = useParams()

  const { data: program } = useQuery({
    queryKey: ["CALL_FOR_FACULTY", params.slug],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate/${params.slug}/open-for-faculty`)

      return data;
    },
    enabled: !!params.slug
  })


  const graduationClass = program?.CourseClasses.find(item => item.classType === "graduation")
  const orientationClass = program?.CourseClasses.find(item => item.classType === "preparation")

  const normalClasses = program?.CourseClasses.filter(item => item.classType === "normal")

  const collapseItems = (normalClasses ?? []).map(item => {
    return {
      key: item.id,
      label: item.title,
      children: <div>Testing bruh</div>
    }
  })

  return (
    <div>
      <div>
        <h3>Certificate Program Name: {program?.title}</h3>
        <h3>Full Program Dates</h3>
        <h3>Start Date (Orientation Session): {moment.utc(orientationClass?.startTime).format("LL")}</h3>
        <h3>End Date (Graduation):  {moment.utc(graduationClass?.startTime).format("LL")}</h3>

        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            flexDirection: "column",
            gap: "1rem"
          }}
        >
          {/*<Collapse*/}
          {/*>*/}
          {/*  {(normalClasses ?? []).map(item => (*/}
          {/*    <Panel header={item.title}>*/}
          {/*      Test*/}
          {/*    </Panel>*/}
          {/*  ))}*/}
          {/*</Collapse>*/}
          {(normalClasses ?? []).map(item => (
            <CallForFacultyClassItem item={item} userProfile={userProfile} />
          ))}
        </div>
      </div>
    </div>
  )
}